<article class="card-shell">
  <header class="card-header">
    <div>
      <h3 class="card-title">{{ title }}</h3>
      <p *ngIf="subtitle" class="card-subtitle">{{ subtitle }}</p>
    </div>

    <span *ngIf="badge" class="card-badge">{{ badge }}</span>
  </header>

  <section class="card-content">
    <ng-content></ng-content>
  </section>

  <footer *ngIf="actionLabel" class="card-footer">
    <button type="button" class="wm-button-secondary" (click)="onAction()">
      {{ actionLabel }}
    </button>
  </footer>
</article>
